import { MAXIMUM_STRIPE_AMOUNT, PAYMENT_FAILED_STATUSES, PAYMENT_STATUSES } from './chunk-BFDKW44N.mjs';
import { InvestmentPaymentCategory } from '@equidefi/constants/payments';

var determineStripePaymentLimit = ({
  creditCardLimit,
  maxStripeAmount = MAXIMUM_STRIPE_AMOUNT
}) => {
  const parsedCCLimit = typeof creditCardLimit === "number" ? creditCardLimit : typeof creditCardLimit === "string" ? Number(creditCardLimit.replace(/[^0-9.-]/g, "")) : creditCardLimit ? Number(creditCardLimit) : Number.NaN;
  const hasValidCCLimit = Number.isFinite(parsedCCLimit) && parsedCCLimit > 0 && parsedCCLimit <= maxStripeAmount;
  return (investmentAmount) => ({
    isOverCreditCardLimit: hasValidCCLimit && investmentAmount > parsedCCLimit,
    isOverTransactionLimit: investmentAmount > maxStripeAmount,
    creditCardLimit: hasValidCCLimit ? parsedCCLimit : null,
    transactionLimit: maxStripeAmount
  });
};
var isPaymentFailed = (payment) => {
  if (!payment) return false;
  return Boolean(payment.is_expired) || PAYMENT_FAILED_STATUSES.some((s) => s === payment.status);
};
var isPaymentAdjustment = (payment) => payment?.category === InvestmentPaymentCategory.ADJUSTMENT;
var latestInvestorPayment = (payments) => payments?.find((payment) => !isPaymentAdjustment(payment));
var canEditPaymentMethod = (investment) => {
  if (!investment) return false;
  if (investment.payment_editable) return true;
  return isPaymentFailed(latestInvestorPayment(investment.payments));
};
var isManualPaymentPending = (payment) => {
  if (!payment) return false;
  return payment.category === InvestmentPaymentCategory.MANUAL && payment.status === PAYMENT_STATUSES.CREATED;
};

export { canEditPaymentMethod, determineStripePaymentLimit, isManualPaymentPending, isPaymentAdjustment, isPaymentFailed, latestInvestorPayment };
